import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import TextField from '../../../common/TextField';
import FileUploadField from '../../../common/FileUploadField';
import Button from '../../../common/Button';
import api from '../../../../utils/api';
import { VacancyApiResponse } from './VacancyForm';
import { useParams } from 'react-router-dom';
import Loading from '../../../common/Loading';

interface VacancyUploadFormProps {
  type: 'add' | 'edit' | 'view';
  onCancel: () => void;
  onSave?: () => void;
}

const VacancyUploadForm: React.FC<VacancyUploadFormProps> = ({ type, onCancel, onSave }) => {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [vacancyUrl, setVacancyUrl] = useState('');
  const [vacancyTinyUrl, setVacancyTinyUrl] = useState('');
  const [socialMedia, setSocialMedia] = useState('');
  const [socialMediaTags, setSocialMediaTags] = useState('');
  const [linkedinImage, setLinkedinImage] = useState<File | null | string>(null);
  const [facebookImage, setFacebookImage] = useState<File | null | string>(null);

  useEffect(() => {
    const vacancyId = params?.id;
    if (type === 'add' || vacancyId === undefined || vacancyId === null) return;

    setIsLoading(true);
    api.get<VacancyApiResponse>(
      `/rec/vacancy/${vacancyId}`,
      {
        headers: {
          'x-api-id': 11,
          'x-page-id': type === 'view' ? 13 : 10,
        },
      }
    ).then((response) => {
      const data = response.data;

      setVacancyUrl(data.vacancyUrl);
      setVacancyTinyUrl(data.vacancyTinyUrl);
      setSocialMedia(data.socialMediaDesc);
      setSocialMediaTags(data.socialMediaTags);
      setLinkedinImage(data.imageLinkedIn);
      setFacebookImage(data.imageFB);
      setIsLoading(false);
    });
  }, [type, params.id]);

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const vacancyId = params.id;
      if (!vacancyId) return;

      const formData = new FormData();

      formData.append('vacancyUrl', vacancyUrl);
      formData.append('vacancyTinyUrl', vacancyTinyUrl);
      formData.append('socialMediaDesc', socialMedia);
      formData.append('socialMediaTags', socialMediaTags);
      if (linkedinImage) {
        formData.append('imageLinkedIn', linkedinImage);
      }
      if (facebookImage) {
        formData.append('imageFB', facebookImage);
      }


      const response = await api.put<VacancyApiResponse>(
        `/rec/vacancy/${vacancyId}/updateMedia`,
        formData,
        {
          headers: {
            'x-api-id': 12,
            'x-page-id': 11,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 200) {
        onSave?.();
      }
    } catch (error) {
      console.error('Error updating vacancy:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box gap={3} display="flex" flexDirection="column">
      {isLoading ? <Loading /> : (
        <>
          <Box className="edit-section">
            <Grid container gap={13}>
              <Grid>
                <Grid>
                  <TextField
                    label="Vacancy URL"
                    width="824px"
                    value={vacancyUrl}
                    onChange={(e) => setVacancyUrl(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid>
                <Grid>
                  <TextField
                    label="Vacancy Tiny URL"
                    width="360px"
                    value={vacancyTinyUrl}
                    onChange={(e) => setVacancyTinyUrl(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box className="edit-section">
            <Grid container gap={13}>
              <Grid container gap={13}>
                <Grid>
                  <TextField
                    label="Social Media"
                    width="360px"
                    value={socialMedia}
                    onChange={(e) => setSocialMedia(e.target.value)}
                  />
                </Grid>
                <Grid>
                  <TextField
                    label="Social Media Tags"
                    width="360px"
                    value={socialMediaTags}
                    onChange={(e) => setSocialMediaTags(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid container gap={1.5}>
                <Grid>
                  <FileUploadField
                    label="Linkedin Image"
                    width="174px"
                    value={linkedinImage}
                    onChange={(file) => setLinkedinImage(file)}
                    accept="image/*"
                    disabled={type === 'view'}
                  />
                </Grid>
                <Grid>
                  <FileUploadField
                    label="Facebook Image"
                    width="174px"
                    value={facebookImage}
                    onChange={(file) => setFacebookImage(file)}
                    accept="image/*"
                    disabled={type === 'view'}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, width: '1502px' }}>
            {type !== 'view' && (
              <>
                <Button
                  variant="outlined"
                  onClick={onCancel}
                  className="edit-section-cancel-button"
                  disabled={isSaving}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  className="edit-section-save-button"
                  disabled={isSaving}
                >
                  {isSaving ? 'Saving...' : 'Save'}
                </Button>
              </>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default VacancyUploadForm; 